// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSUpload/Avatar/index.less
// module id = 774
// module chunks = 42